package hk.com.vr360_demo2.webapp

import web.cssom.Color

object Colors {
    object Text {
        val Black: Color = Color("#2E2E2E")
        val Gray: Color = Color("#75829E")
        val Primary: Color = Color("#f26522")
        val White: Color = Color("#FFFFFF")
    }

    object Background {
        val Gray: Color = Color("#EDEDF3")
        val White: Color = Color("#FFFFFF")
        val Semitransparent: Color = Color("rgba(0,0,0,0.5)")
        val Primary: Color = Color("#f26522")
    }

    object Stroke {
        val LightGray: Color = Color("#F4F4F4")
        val Gray: Color = Color("#DEE1E9")
        val Primary: Color = Color("#f26522")
        val White: Color = Color("#ffffff")
    }
}
